import { GOOGLE_MAPS_API_KEY } from "../Components/Services/baseApiUrl";

export const GOOGLE_MAPS_LOADER_ID = "swm-google-maps";
export const GOOGLE_MAPS_LIBRARIES = ["places"];

export const googleMapsLoaderOptions = {
  id: GOOGLE_MAPS_LOADER_ID,
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};
